<div class="sign-up-wrapper">
	<div class="su-content">
		<form [formGroup]="filters" *ngIf="filters">
			<div class="su-header">
				<div *ngIf="this.flexPeriodService.flexPeriod$(this.data?.flexPeriodId) | async as flexPeriod">
					<p
						*ngIf="calendarService.showSignupCloseAlert(data.calendarEvent, flexPeriod)"
						class="tw-text-red-500 tw-bg-red-100 tw-px-3 tw-py-2 tw-mt-0 tw-rounded-full tw-flex tw-w-max">
						<bp-icon class="tw-pr-1" icon="sand-timer"></bp-icon> {{ calendarService.getSignupState(data.calendarEvent, flexPeriod).tooltip }}
					</p>
					<p class="tw-text-navy-500 tw-text-2xl tw-font-bold tw-m-0">Sign Up for {{ flexPeriod?.name }}</p>
					<p class="tw-text-navy-500 tw-text-lg tw-font-medium tw-mt-2 tw-mb-0">
						{{ data.calendarEvent?.start | date : 'MMMM d h:mm a' }} - {{ data.calendarEvent?.end | date : 'h:mm a' }}
					</p>
				</div>
			</div>
			<div class="su-divider tw-my-7"></div>
			<div class="su-filters">
				<div>
					<select formControlName="availability" class="secondary">
						<option [value]="false">Include unavailable activities</option>
						<option [value]="true" selected>Only available activities</option>
					</select>
				</div>
				<div class="search-bar">
					<img [src]="'./assets/Search Normal (Blue-Gray).svg' | resolveAsset" alt="search" />
					<input class="su-search" type="text" placeholder="Search" formControlName="search" />
				</div>
			</div>
			<ng-container *ngIf="visibleInstances$ | async as instancesWithLoading">
				<ng-container *ngIf="instancesWithLoading.loading">
					<div class="no-activities">
						<div>Loading activities...</div>
					</div>
				</ng-container>
				<ng-container *ngIf="instancesWithLoading.error">
					<div class="no-activities">
						<div>Error encountered while retrieving activities. Try refreshing the page..</div>
					</div>
				</ng-container>
				<ng-container *ngIf="!instancesWithLoading.loading">
					<ng-container *ngIf="instancesWithLoading.instances.length > 0; else noActivities">
						<div class="su-activities">
							<sp-activity
								*ngFor="let vi of instancesWithLoading.instances"
								[activity]="vi.activity"
								[instance]="vi.instance"
								[isSelected]="vi.instance.selected"
								(selected)="signUp($event)"></sp-activity>
						</div>
					</ng-container>
				</ng-container>
				<ng-template #noActivities>
					<div class="no-activities">No activities available.</div>
				</ng-template>
			</ng-container>
		</form>
	</div>
</div>

<ng-template #loading let-loading="loading"> </ng-template>
